import React from 'react'
import styled from 'styled-components'
import { Row, Col, Modal, Divider, Badge } from 'antd'
import { COLUMNS_MAPPING, COLUMNS_INFO } from './../columns'

const Item = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    padding: 20px 5px;
    border-radius: 2px;
    height: 250px;
    border: 1px solid #ddd;
    transition: all 0.3s;
    &:hover {
        transform: translateY(-5px);
    }
    .name {
        margin-bottom: 5px;
        padding: 5px 15px;
        font-size: 16px;
        text-transform: capitalize;
        background: #2c3e50;
        color: #fff;
        border-radius: 20px;
    }
    .image {
        width: 100%;
        height: 100%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
    }
`

const ColumnSelector = ({ T, isOpen, onSelect, onClose }) => (
    <Modal
        title={T('SELECT_COLUMN_STYLE')}
        footer={null}
        width={720}
        visible={isOpen}
        onCancel={() => onClose()}>
        {COLUMNS_MAPPING.map(group => (
            <React.Fragment key={group.groupType}>
                <Divider orientation="left">{T(group.groupType)}</Divider>
                <Row type="flex" gutter={15}>
                    {group.columnsType.map(columnType => (
                        <Col key={columnType} xs={12} lg={8}>
                            <ColumnTag tag={COLUMNS_INFO[columnType].tag}>
                                <Item onClick={() => onSelect(columnType)}>
                                    <div className="name">
                                        {T(COLUMNS_INFO[columnType].name)}
                                    </div>
                                    <div
                                        className="image"
                                        style={{
                                            backgroundImage: `url(${
                                                window.config.themeUrl
                                            }/manager/static/images/layout-column/${
                                                COLUMNS_INFO[columnType]
                                                    .image || ''
                                            })`
                                        }}
                                    />
                                </Item>
                            </ColumnTag>
                        </Col>
                    ))}
                </Row>
            </React.Fragment>
        ))}
    </Modal>
)

const ColumnTag = ({ tag, children }) => {
    if (tag) {
        return (
            <Badge.Ribbon text={tag} color="red">
                {children}
            </Badge.Ribbon>
        )
    }
    return children
}

export default ColumnSelector
